export default __webpack_public_path__ + "static/media/classtrack_f2.5e05b8f5.png";